import { Component, OnInit } from '@angular/core';

import { SummitIdObject, ViewField } from '@summit/models';

import { ReactiveFormsModule } from '@angular/forms';
import { SummitControl } from '../../models';
import { SFormErrorInputComponent } from '../s-form-error-input';

@Component({
  selector: 's-form-input-hidden',
  templateUrl: './s-form-input-hidden.component.html',
  styleUrls: ['./s-form-input-hidden.component.scss'],
  standalone: true,
  imports: [SFormErrorInputComponent, ReactiveFormsModule]
})
export class SFormInputHiddenComponent<T extends SummitIdObject> extends SummitControl<T> implements OnInit {
  property: ViewField<T>;
}
